module.exports = __webpack_public_path__ + "static/media/ipt_logo.91b15cba.svg";